import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "iconoir-react";
import { useLanguage } from "@/components/LanguageContext";

export function Footer() {
  const { t } = useLanguage();

  const footerLinks = [
    {
      title: t("Entreprise", "Company"),
      links: [
        { label: t("À propos", "About"), href: "/about" },
        { label: t("Services", "Services"), href: "/services" },
        { label: t("Solutions", "Solutions"), href: "/solutions" },
        { label: t("Projets", "Projects"), href: "/projects" },
      ],
    },
    {
      title: t("Plateforme", "Platform"),
      links: [
        { label: t("Logiciels & Apps", "Software & Apps"), href: "/software" },
        { label: t("Partenaires", "Partners"), href: "/partners" },
      ],
    },
    {
      title: t("Expertise", "Expertise"),
      links: [
        { label: t("Planification Mobilité", "Mobility Planning"), href: "/services" },
        { label: t("SIG & Intelligence", "GIS & Intelligence"), href: "/services" },
        { label: t("Développement Durable", "Sustainability"), href: "/services" },
        { label: t("IA & Analytics", "AI & Analytics"), href: "/services" },
      ],
    },
  ];

  return (
    <footer className="bg-charcoal text-warm-white/80">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-5">
            <div>
              <h3 className="text-2xl font-bold text-warm-white font-display tracking-tight">
                AVISI<span className="text-amber">U</span>M
              </h3>
              <p className="text-xs uppercase tracking-[0.25em] text-warm-white/40 mt-1">
                Solutions Group
              </p>
            </div>
            <p className="text-sm leading-relaxed text-warm-white/60 max-w-sm">
              {t(
                "Façonner les systèmes de mobilité, l'infrastructure et l'intelligence territoriale pour des villes durables.",
                "Shaping mobility systems, infrastructure, and territorial intelligence for sustainable cities and regions."
              )}
            </p>
            <div className="space-y-2 text-sm text-warm-white/50">
              <div className="flex items-center gap-2">
                <MapPin width={14} height={14} />
                <span>{t("Temara, Maroc", "Temara, Morocco")}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail width={14} height={14} />
                <span>contact@avisium.ma</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone width={14} height={14} />
                <span>+212 710 33 53 53</span>
              </div>
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-warm-white/40 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-warm-white/60 hover:text-amber transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-warm-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-warm-white/30">
            © {new Date().getFullYear()} AVISIUM Solutions Group. {t("Tous droits réservés.", "All rights reserved.")}
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/avisium-solutions-group/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              className="text-warm-white/30 hover:text-amber transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin width={18} height={18} />
            </a>
            <a
              href="https://wa.me/212710335353"
              target="_blank"
              rel="noopener noreferrer"
              className="text-warm-white/30 hover:text-amber transition-colors"
              aria-label="WhatsApp"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                <path d="M12.031 0C5.392 0 0 5.39 0 12.028c0 2.128.553 4.2 1.603 6.02L.15 23.334l5.422-1.423a11.96 11.96 0 005.856 1.839h.005c6.638 0 12.03-5.385 12.03-12.023A12.043 12.043 0 0012.031 0zm.006 20.06a9.982 9.982 0 01-5.1-1.401l-.364-.216-3.8.995.998-3.702-.236-.379a9.96 9.96 0 01-1.526-5.328c0-5.5 4.475-9.972 9.982-9.972 2.665.003 5.168 1.041 7.051 2.924a9.965 9.965 0 012.919 7.052c-.001 5.498-4.477 9.972-9.98 9.972h-.001zM17.5 14.053c-.302-.15-1.792-.884-2.072-.986-.279-.101-.482-.152-.686.15-.203.303-.787.986-.967 1.188-.178.203-.36.227-.66.077-1.411-.703-2.583-1.63-3.615-2.822-.26-.298.261-.274.843-1.442.078-.152.038-.284-.037-.435-.077-.152-.686-1.65-.94-2.261-.248-.595-.502-.516-.687-.525-.176-.008-.378-.01-.58-.01a1.114 1.114 0 00-.814.382c-.28.303-1.066 1.042-1.066 2.54 0 1.5.111 2.274.686 3.033.565.759 2.115 3.321 4.792 4.469 1.942.83 2.5.892 3.134.787.653-.108 2.07-.845 2.365-1.67.293-.82.293-1.524.205-1.666-.089-.142-.33-.217-.633-.37z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
